module.exports = __webpack_public_path__ + "media/images/homepage/vector2-829baf06087c3cf456f42b8b69b0a619.png";